<template>
  <div>
    <div id="" ref="ancora"></div><!-- ANCORA SCROLL -->
    <bread-crumb :categorialeilao="leilao.categorialeilao"></bread-crumb><!-- MAPA NAVEGACAO -->
    <Stretch v-show="loadingPage">Carregando...</Stretch><!-- LOADING -->
    <div v-if="naoEncomtrado == true"><!-- MENSAGEM DE NÃO ENCONTRADO -->
      <nao-encontrado :leilaoId="leilao.id" :cookie="cookie"></nao-encontrado>
    </div>

    <div v-show="loadingPage == false && naoEncomtrado == false"><!-- RESULTADO DA BUSCA -->
      <!-- <filtro :leilao="leilao" :filtros="filtros" :iscategoria="true"></filtro> -->
      <Stretch v-show="loadingRefresh">Carregando...</Stretch><!-- LOADING INTERNO -->
      <div class="pag-container-vu paginatio-mobile" style="clear:both;"
           v-show="firstLoadCategoria == false && loadingRefresh == false">
        <paginate
          v-model="paginaAtual"
          :page-count="Number(paginator.pageCount)"
          :page-range="3"
          :margin-pages="2"
          :click-handler="clickCallback"
          :prev-text="'Anterior'"
          :next-text="'Próximo'"
          :container-class="'pagination'"
          :page-class="'page-item'">
        </paginate>
        <div class="clearfix"></div>
      </div>
      <div id="target_scroll"></div>
      <div v-for="(leilao,idx) in lotesAgrupados" :key="idx" class="grupo-leilao">
        <header-disputa :leilaoid="leilao.leilao_id" :lotes="leilao.lotes"></header-disputa>
        <ul :id="'grid-'+leilao.leilao_id" class="products-grid columns4"
            v-show="firstLoadCategoria == false && loadingRefresh == false">
          <li v-for="(lote,idx2) in leilao.lotes" :key="idx2" class="lote-item">
            <card :leilao="leilao.leilao" :dados="lote" :liberado="leilao.liberado" :automatico="leilao.fechamento"
                  :usuarioid="usuario.id"></card>
          </li>
        </ul>
      </div>
    </div>

    <div class="pag-container-vu" v-show="firstLoadCategoria == false && loadingRefresh == false">
      <paginate
        v-model="paginaAtual"
        :page-count="Number(paginator.pageCount)"
        :page-range="3"
        :margin-pages="2"
        :click-handler="clickCallback"
        :prev-text="'Anterior'"
        :next-text="'Próximo'"
        :container-class="'pagination'"
        :page-class="'page-item'">
      </paginate>
    </div>
  </div>
</template>
<script>
import Card from '@/components/shared/Card'
import Paginate from 'vuejs-paginate'
import {Stretch} from 'vue-loading-spinner'
import {Carousel, Slide} from 'vue-carousel'

//LAYOUT COMPONENT
import BreadCrumb from '@/components/shared/BreadCrumb'
import BotoesRotas from '@/components/shared/BotoesRotas'
import NaoEncontrado from '@/components/shared/NaoEncontrado'
import HeaderDisputa from '@/components/shared/HeaderDisputa'
import MensagemBox from '@/components/shared/MensagemBox'
import Filtro from '@/components/shared/Filtro'

export default {
  name: 'SalaDisputa',
  components: {
    BreadCrumb,
    Card,
    Stretch,
    Paginate,
    Carousel,
    Slide,
    BotoesRotas,
    NaoEncontrado,
    HeaderDisputa,
    MensagemBox,
    Filtro
  },
  data() {
    return {
      leilao: {},
      lotes: [],
      lotesFiltrados: [],
      config_leiloeiro: [],
      dados_condicao: [],
      usuario: [],
      paginator: [],
      filtros: [],
      errors: [],
      lotesAgrupados: [],
      loadingPage: true,
      loadingRefresh: false,
      naoEncomtrado: false,
      firstLoadCategoria: true,
      paginaAtual: 1,
      parametrosFiltro: '',
      refreshCountBusca: 30000,
      cookie: true,
      //DADOS VINDOS DA PESQUISA
      tipo: 0,
      subcategoria_id: 0,
      palavra_chave: '',
      csrfid: '',
      method: sessionStorage.getItem('PesquisaMethod') || 'GET',
      existeParametro: false,
      // auxilio para comunicacao com firebase
      saladisputa: null,
      lotesStatusReference: [],
      lotesLanceReference: [],
      lotesIncrementoReference: [],
      lotesDtfechamentoReference: [],
      firebaseConnection: null,
      firebaseDb: null,
      porPagina: 5,
      leilaoCollection: {},
      search: {
        leilao: {
          nm_titulo: '',
          nm_descricao: ''
        },
        lote: {}
      },

      dataCache: {
        leilao: {},
        lotes: {}
      }
    }
  },
  methods: {
    callData(pageNumber, FiltroLoad) { // REQUEST DOS DADOS LISTAGEM - SALA DE DISPUTA

      const hostName = location.protocol + "//" + window.HOSTNAME
      const pageNum = pageNumber ? `?page=${pageNumber}` : ''
      const FiltroL = pageNum ? `&${FiltroLoad}` : `?${FiltroLoad}`
      const changeFiltro = FiltroLoad ? FiltroL : ''
      const self = this

      if (pageNumber) {
        this.paginaAtual = pageNumber
      }

      const dadosFormPesquisa = sessionStorage.getItem('dadosPesquisa')
      const jsonFormPesquisa = dadosFormPesquisa ? JSON.parse(dadosFormPesquisa) : dadosFormPesquisa

      if (this.$route.query.leilao_nm_titulo) {
        this.search.leilao.nm_titulo = this.$route.query.leilao_nm_titulo
      }
      if (this.$route.query.leilao_nm_descricao) {
        this.search.leilao.nm_descricao = this.$route.query.leilao_nm_descricao
      }

      if (this.$route.query.somente_aberto) {
        this.search.leilao.somente_aberto = 1
      }

      if (this.$route.query.ordenar_visitas) {
        this.search.leilao.ordenar_visitas = 1
      }

      // pode existir querystring para identifica tipo e subcategoria, no caso da sato
      if (this.$route.query.segmento_id) {
        self.tipo = parseInt(this.$route.query.segmento_id)
      }
      if (this.$route.query.subcategoria_id) {
        self.subcategoria_id = parseInt(this.$route.query.subcategoria_id)
      }
      if (this.$route.query.palavra_chave) {
        self.palavra_chave = this.$route.query.palavra_chave
      }

      if (jsonFormPesquisa !== null) {
        for (let f of jsonFormPesquisa) {
          if (f.name === 'tipo') {
            self.tipo = parseInt(f.value)
          }
          if (f.name === 'subcategoria_id') {
            self.subcategoria_id = parseInt(f.value)
          }
          if (f.name === 'palavra_chave') {
            self.palavra_chave = f.value
          }
          if (f.name === 'csrfid') {
            self.csrfid = f.value
          }
        }
      }

      let urlRequest = ''
      if (this.$route.query.subcategoria_id) {
        this.existeParametro = true
        this.method = 'GET'
        urlRequest = `${hostName}/index/busca-categoria/subcategoria_id/${this.$route.query.subcategoria_id}/segmento_id/${this.$route.query.segmento_id}/firebase/1${pageNum}${changeFiltro}`
      } else {
        urlRequest = `${hostName}/busca/pesquisar-site/firebase/1${pageNum}${changeFiltro}`
      }

      this.searchLote(this.palavra_chave);
    },
    refreshFirebase() {
      this.saladisputa.refreshLotesAgrupados(this.lotesFiltrados)
    },

    sortBySeq(lote1, lote2) {
      if (lote1.leilao_id === lote2.leilao_id) {
        if (lote1.seq > lote2.seq) {
          return 1;
        }
        if (lote1.seq < lote2.seq) {
          return -1
        }
        return 0;
      }
      return 0;
    },

    removeSession() {
      sessionStorage.removeItem('dadosPesquisa')
      sessionStorage.removeItem('PesquisaMethod')
    },

    clickCallback(pageNum) { // ATUALIZA O NÚMERO DA PÁGINA ATUAL PARA AMBOS (PAGINACAO)
      this.loadingRefresh = true
      this.callData(pageNum)
      this.$refs.ancora.scrollIntoView({behavior: 'smooth'})
    },

    searchInValue(search, value) {
      value = !value ? '' : value
      return this.retira_acentos(value).toLowerCase().search(this.retira_acentos(search).toLowerCase()) !== -1
    },

    sortLeilao(item1, item2) {
      let leilao1 = this.leilaoCollection[item1.leilao_id]
      let leilao2 = this.leilaoCollection[item2.leilao_id]

      if(!!leilao1 && !!leilao2){
        if(leilao1.ordem === leilao2.ordem){
          return leilao1.seq < leilao2.seq
        }
        return leilao1.ordem < leilao2.ordem
      }
    },

    sortVisitas(item1, item2) {
      let leilao1 = this.leilaoCollection[item1.leilao_id]
      let leilao2 = this.leilaoCollection[item2.leilao_id]
      let visitas1 = parseInt(leilao1.nu_visitas_leilao)
      let visitas2 = parseInt(leilao2.nu_visitas_leilao)

      if (visitas1 < visitas2) {
        return 1
      }

      if (visitas1 > visitas2) {
        return -1
      }

      return 0
    },

    filterLeilao(item) {
      let lote = Object.values(item)[0]
      let leilao = this.leilaoCollection[lote.leilao_id]
      if (!leilao || !leilao.dt_formatado) {
        return false
      }
      let d = leilao.dt_formatado
      if (leilao.dt_segundoleilao_data) {
        d = leilao.dt_segundoleilao_data
      }
      d = d.replace(/^(\d{2})\/(\d{2})\/(\d{4}).*$/, '$3-$2-$1 00:00:00')
      let dt = new Date(d)
      let hoje = new Date()
      // console.log(leilao, `${dt.getFullYear()}${(dt.getMonth() + 1).toString().padStart(2, "0")}${dt.getDate().toString().padStart(2, "0")}` >= `${hoje.getFullYear()}${(hoje.getMonth() + 1).toString().padStart(2, "0")}${hoje.getDate().toString().padStart(2, "0")}`, `${dt.getFullYear()}${(dt.getMonth() + 1).toString().padStart(2, "0")}${dt.getDate().toString().padStart(2, "0")}`, `${hoje.getFullYear()}${(hoje.getMonth() + 1).toString().padStart(2, "0")}${hoje.getDate().toString().padStart(2, "0")}`)
      return `${dt.getFullYear()}${(dt.getMonth() + 1).toString().padStart(2, "0")}${dt.getDate().toString().padStart(2, "0")}` >= `${hoje.getFullYear()}${(hoje.getMonth() + 1).toString().padStart(2, "0")}${hoje.getDate().toString().padStart(2, "0")}`
    },

    verificaCategoria(lote) {
      let categoria = true
      let subCategoria = true

      if (this.tipo === 4 && this.palavra_chave === '' && this.subcategoria_id === 0) {
        this.removeSession()
        this.$router.push('/leilao/index/judicial')
      }

      if (this.tipo === 4 && this.palavra_chave !== '') {
        if (lote.judicial) {
          for (let item of Object.keys(lote.judicial)) {
            item = lote.judicial[item]
            if (item.toLowerCase) {
              if (this.searchInValue(this.palavra_chave, this.retira_acentos(item))) {
                return true
              }
            }
          }
        }
      }

      if (this.tipo > 0) {
        categoria = lote.vistoria.some(item => item.id_segmento === this.tipo)
      }
      if (this.subcategoria_id > 0) {
        subCategoria = lote.vistoria.some(item => item.id_subcategoria === this.subcategoria_id)
      }
      if (lote.lote_id === 7844) {
      }
      return categoria && subCategoria
    },

    // se existir o valor em nm, retorna todos os lotes
    pesquisaTituloLeilao(keyword, lote) {
      // lote = Object.values(lote)[0]
      let leilao = this.leilaoCollection[lote.leilao_id]

      if (!leilao || !leilao.dt_formatado) {
        return false
      }

      return this.searchInValue(keyword || '', this.retira_acentos(leilao.nm) || '')
    },

    pesquisaDescricaoLote(keyword, lote) {
      return this.searchInValue(keyword || '', this.retira_acentos(lote.nm_descricao) || '')
    },

    // se existir o valor em nm_descricao, retorna todos os lotes
    pesquisaDescricaoLeilao(keyword, lote) {
      // lote = Object.values(lote)[0]
      let leilao = this.leilaoCollection[lote.leilao_id]

      if (!leilao || !leilao.dt_formatado) {
        return false
      }

      return this.searchInValue(keyword || '', this.retira_acentos(leilao.nm_descricao) || '')
    },
    pesquisaLeilaoSomenteAberto(lote) {
      // lote = Object.values(lote)[0]
      let leilao = this.leilaoCollection[lote.leilao_id]
      if (!leilao || !leilao.dt_formatado) {
        return false
      }
      //console.log((leilao.statusmontagem_id == 2) || (leilao.statusmontagem_id == 3));
      //return (leilao.statusmontagem_id == 4) || (leilao.statusmontagem_id == 5) // forçar erro
      return (leilao.statusmontagem_id == 2) || (leilao.statusmontagem_id == 3)
    },

    pesquisaInformacoesLote(search, resolve) {
      search = this.retira_acentos(search);

      const data2 = this.dataCache.lotes;
      const newData = Object.values(data2)
        .filter(this.filterLeilao)
        .flatMap((o) => Object.values(o))
        .filter((lote) => {

          if(!!lote.vistoria){
            if (search) {
              if (!!this.pesquisaDescricaoLote(search, lote) || !!this.pesquisaTituloLeilao(search, lote) || !!this.pesquisaDescricaoLeilao(search, lote)) {

                if(this.tipo === 0){
                  return lote;
                }

                if(this.tipo === 5){
                  if(this.leilaoCollection[lote.leilao_id].statusleilao_id === 18 || this.leilaoCollection[lote.leilao_id].statusleilao_id === 13){
                    return lote;
                  }
                }

                if(this.tipo === 4 && !!lote.judicial){
                  return lote;
                }

                if(!!!lote.vistoria[0].id_categoria){
                  if(!!lote.vistoria[0].equipamento_id && this.tipo === 2){
                      return lote;
                  }
                }

                if (this.tipo === lote.vistoria[0].id_categoria) {
                  return lote;
                }
              }
            }
          }
        });

      let newData2 = newData.slice(0, this.porPagina + 1);

      if (this.search.leilao.ordenar_visitas) {
        newData2.sort(this.sortVisitas);
      } else {
        newData2.sort(this.sortLeilao);
      }

      resolve({
        data: {
          lotes: newData2,
          usuario: { id: null },
          filtros: { tipo: 0, subcategoria_id: '', segmento_id: 0 },
          titulo_busca: `resultados para busca: '${search}'`,
          paginator: {
            totalItemCount: newData.length,
            itemCountPerPage: this.porPagina,
            pageCount: Math.ceil(newData.length / this.porPagina),
            pages: { itemCountPerPage: this.porPagina, },
          },
        },
      });
    },

    async searchLote(search) {
      const self = this
      const fire = this.firebase_db;
      const hostName = location.protocol + "//" + window.HOSTNAME

      if(!!!self.palavra_chave){
        alert("Preencha o campo pesquisa!");
        self.loadingPage   = false
        self.naoEncomtrado = true
        return false
      }

      if (Object.keys(this.dataCache.lotes).length) {
        var response = await new Promise((resolve, reject) => this.pesquisaInformacoesLote(search, resolve))
      }

      var response = await new Promise((resolve, reject) => {
        fire.ref(`/leilao`).once('value', data => {
          this.leilaoCollection = data.val()
          fire.ref(`/lote`).once('value', data => {
            this.dataCache.lotes = data.val()
            this.pesquisaInformacoesLote(search, resolve);
          })
        })
      })

      if (response.data.lotes.length <= 0) {
        self.loadingPage = false
        self.naoEncomtrado = true
        return false
      }

      self.lotes = response.data.lotes.sort(this.sortBySeq)
      self.lotesFiltrados = response.data.lotes.sort(this.sortBySeq)
      self.usuario = response.data.usuario

      this.saladisputa.observaLotesStatusLance(self.lotesFiltrados)

      self.leilao.categorialeilao = [
        {"id": 200, "leilao_id": 29, "categorialeilao_id": 1, "nm_categoria": "Veículos"},
        {"id": 201, "leilao_id": 29, "categorialeilao_id": 2, "nm_categoria": "Equipamentos"},
        {"id": 202, "leilao_id": 29, "categorialeilao_id": 3, "nm_categoria": "Imóveis"},
        {"id": 203, "leilao_id": 29, "categorialeilao_id": 5, "nm_categoria": "Semoventes"}
      ]

      self.paginator = response.data.paginator
      self.filtros = response.data.filtros


      //GERANDO GRUPO DE CATEGORIA POR LEILAO
      if (self.firstLoadCategoria || self.loadingRefresh) {
          const cacheKeyValue = {};
          self.lotesAgrupados = [];

          self.lotesFiltrados.forEach((lote) => {
            const leilaoId = lote.leilao_id;

            if (this.leilaoCollection[leilaoId].leilao_id_primeiroleilao) {
              const primeiroLeilaoId = this.leilaoCollection[leilaoId].leilao_id_primeiroleilao;
              const lotesPrimeiroLeilao = self.lotesFiltrados.filter(l => l.leilao_id === primeiroLeilaoId);

              const lotePrimeiro = lotesPrimeiroLeilao.find(l => l.nu === lote.nu);
              if (lotePrimeiro) {
                const primeiro = self.saladisputa.vistoriaCampos(lotePrimeiro);
                lote.primeiro_vistoria_vl_lanceinicial = primeiro.vistoria_vl_lanceinicial;
              }
            } else {
              lote = self.saladisputa.vistoriaCampos(lote);
            }

            if (cacheKeyValue[leilaoId]) {
              return; // Skip if leilaoId is already in cache
            } else {
              cacheKeyValue[leilaoId] = true;
            }

            const lotesDoLeilao = self.lotesFiltrados.filter(l => l.leilao_id === leilaoId);
            self.lotesAgrupados.push({
              leilao: this.leilaoCollection[leilaoId],
              leilao_id: leilaoId,
              liberado: false,
              fechamento: false,
              lotes: lotesDoLeilao,
            });
          });
        }

      self.saladisputa.refreshLotesAgrupados(self.lotesFiltrados)

      self.lotesAgrupados.map((item, i) => {
        fetch(`${hostName}/leilao/get-leilao-busca?leilao_id=${item.leilao_id}`)
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! Status: ${res.status}`);
            }
            return res.json();
          })
          .then((res) => {
          self.lotesAgrupados.leilao = res.leilao
          self.lotesAgrupados.dados_condicao = res.dados_condicao
          self.lotesAgrupados.usuario = res.usuario
          self.lotesAgrupados.config_leiloeiro = res.config_leiloeiro

          self.loadingPage = false
          self.loadingRefresh = false

        }).catch(e => {
          this.errors.push(e)
        })
      })

      if (this.errors.length > 0) {
        this.naoEncomtrado = true
        this.loadingPage = false
      }

      self.firstLoadCategoria = false
      // this.removeSession() // Voltar codigo
    },

    retira_acentos(str) {
      return (str || '').normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }
  },

  created() { // INIT
    this.loadingPage = true

    clearInterval(window.INTERVALO_BUSCA)
    clearInterval(window.INTERVALO_CATEGORIA)

    this.saladisputa = new window.saladisputa(this)
    this.callData()

    //verifica cookie e browser
    this.cookie = this.$root.cookieAtivo
    this.$root.MensagemBrowserCookie()
  }
}
</script>
<style>
.doc-icons {
  cursor: pointer;
  text-align: center;
}

.dialog-content {
  max-height: 400px;
  overflow: auto;
}

.boxRegulamento {
  padding: 0px !important;
}

.container-box {
  height: auto !important;
  width: 100% !important;
  overflow: inherit !important;
}

#portotemplate .spinner {
  margin: 0 auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 200px;
}

#portotemplate .spinner div {
  background-color: #67302b !important;
}

#portotemplate a:hover, #portotemplate a:focus {
  text-decoration: none;
}

.VueCarousel-navigation a.VueCarousel-navigation-prev {
  left: 24px !important;
  background: #fff;
  border-radius: 2px;
}

.VueCarousel-navigation a.VueCarousel-navigation-next {
  right: 24px !important;
  border-radius: 2px;
  background: #fff;
}

.VueCarousel-navigation a.VueCarousel-navigation--disabled {
  display: none;
}

.pag-container-vu {
  width: 98%;
  margin: 20px auto;
  text-align: center;
}

#portotemplate .pagination > li:first-child > a, #portotemplate .pagination > li:last-child > a, #portotemplate .pagination > li:last-child > span {
  padding: 2px 5px;
}

#portotemplate .li-hidden {
  display: none;
}

@media (max-width: 600px) {
  .pagination {
    margin-top: 60px !important;
    margin-bottom: -8px !important;
  }
}

.grupo-leilao {
  background: #fcf8e9;
  padding: 14px 15px;
  margin: 17px 0;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Busca.vue